export const kP11LinkService = {
  async fetchKeapPartnerUserDetails(run, client, user) {
    return client(`user?email=${user.email}`)
  },
  async fetchAccountInformationByEmail(run, client, email, accountCode) {
    const acctParam = accountCode
      ? `&accountCode=${encodeURIComponent(accountCode)}`
      : ''
    return client(
      `orders/validate-email/${email}?fetchSubDetail=true&keapClient=true${acctParam}`,
    )
  },
  async fetchSubscriptionByThryvId(run, client, thryvId, keapClient) {
    return client(
      `accounts/5/subscriptions?thryvId=${thryvId}&keapClient=${keapClient}`,
    )
  },
  async validateClientEmail(run, client, email) {
    return client(
      `orders/validate-email/${email}?fetchSubDetail=true&keapClient=true`,
    )
  },
  async validateSEOProposalId(run, client, alphaProposalId) {
    return client(
      `orders/alphaseo/validate-proposal?proposalId=${alphaProposalId}`,
    )
  },
  async validateThryvLeadsProposalId(run, client, leadsId) {
    return client(`plans/validate-thryv-leads/${leadsId}`)
  },
  async confirmScheduleSlot(client, url, payload) {
    return client(url, {data: payload})
  },
  async fetchAvailableTimeSlot(client, url) {
    return client(url)
  },
  async captureAppoinmentDetail(client, url, payload) {
    return client(url, {data: payload})
  },
  async validateExistingWebsiteUrl(run, client, websiteUrl) {
    return client(`orders/validate-website/${websiteUrl}`)
  },
  async fetchPartnerAffiliateCodeByEaid(client, eaid) {
    return client(`esb/partner-affiliate-code?eaid=${eaid}`)
  },
  async fetchPartnerEaidByEmail(client, email) {
    return client(`salesforce/services/getPartnerEAID?email=${email}`)
  },
}
